// extracted by mini-css-extract-plugin
module.exports = {"root":"ShowMore_root__cw2e_","button":"ShowMore_button__FVEJJ"};